import { apiTimeout } from 'Components/Misc/CaseDetails_System';

/**
 * Matches Contract Hub agreement resource paths only:
 *   /v2/contract/hub/agreement
 *   /v2/contract/hub/agreement/123
 *   /v2/contract/hub/agreement?foo=1
 *
 * Intentionally does NOT match sibling endpoints such as:
 *   /v2/contract/hub/agreementStats
 *   /v2/contract/hub/agreementHistory
 */
const CONTRACT_HUB_AGREEMENT_PATH =
  /\/v2\/contract\/hub\/agreement(?:\/|\?|#|$)/i;

/**
 * Single source of truth for axios request timeout + bypass rules.
 *
 * Used by OOT / Workflow / Configurator interceptors so a bypass in one
 * place is not overwritten by another interceptor on the shared axios instance.
 *
 * Bypasses (temporary workarounds — keep in sync with product intent):
 * - api/sync-offer (ECE_COMOPS-11720)
 * - api/configurator/ (Zendesk)
 * - /v2/contract/hub/agreement[/{id}] (Contract Hub agreement APIs — ECE_COMOPS-17843)
 */
export const shouldBypassApiTimeout = (request: {
  url?: string;
  method?: string;
}): boolean => {
  const url = request.url ?? '';

  return (
    url.includes('api/sync-offer') ||
    url.includes('api/configurator/') ||
    CONTRACT_HUB_AGREEMENT_PATH.test(url)
  );
};

/** Apply the standard API timeout unless the request matches a bypass rule. */
export const applyApiTimeout = <T extends { url?: string; method?: string; timeout?: number }>(
  request: T,
): T => {
  if (!shouldBypassApiTimeout(request)) {
    request.timeout = 1000 * apiTimeout;
  }
  return request;
};
